"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SheetMusicSingProps = void 0;

var _vue = require("vue");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));

var _webMusicGrade = require("@evideo/web-music-grade");

var _spin = _interopRequireDefault(require("ant-design-vue/lib/spin"));

require("ant-design-vue/lib/spin/style/index.css");

var _lodash = _interopRequireDefault(require("lodash"));

var _useSheetMusicBusiness = _interopRequireDefault(require("../hooks/useSheetMusicBusiness"));

var _useSheetMusicPlay2 = _interopRequireDefault(require("../hooks/useSheetMusicPlay"));

var _A = _interopRequireDefault(require("./assets/A4.mp3"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var sheetMusicSingProps = {
  sheetMusicSingEl: Object,
  song: Object,
  style: Object,
  sheetOption: Object,
  recordScoreOptions: Object,
  midiTestRecordScore: Boolean,
  disabled: Boolean,
  preloadAudio: {
    // 预请求音频
    type: Boolean,
    default: true
  },
  debugger: {
    default: true
  },
  loadSheetMode: {
    type: String,
    default: 'svgStr'
  },
  svgApi: {
    type: String,
    default: 'https://devpcloud-pre-render-service.ecoach.evideo.tech/sheet-svg/render-data'
  },
  loadFluidSynthJs: {
    type: Function
  }
};
exports.SheetMusicSingProps = sheetMusicSingProps;
var SheetMusicSing = (0, _vue.defineComponent)({
  name: 'SheetMusicSing',
  components: {
    Spin: _spin.default
  },
  props: sheetMusicSingProps,
  emits: ['onError', 'onLoading', 'recordSuccess', 'onReSingConfirm', 'audioCacheSuccess', 'audioCacheError'],
  setup: function setup(props, ctx) {
    var _this = this;

    var _a;

    var loading = (0, _vue.ref)(false);
    var loadingTip = (0, _vue.ref)('设置曲谱中...');
    var isInitPlayerTool = (0, _vue.ref)(false);
    var isPlaying = (0, _vue.ref)(false);
    var isSingPlaying = (0, _vue.ref)(false);
    var isReplayPlaying = (0, _vue.ref)(false);
    var svgContainerVisible = (0, _vue.ref)(true);
    var initSuccess = (0, _vue.ref)(true); //曲谱音频初始化状态

    var destroyAllFlag = (0, _vue.ref)(false); //记录父组件是否调用destroyAll方法

    var replayVisible = (0, _vue.ref)(!!props.song.recordFileUrl);
    var midiTestRecordScore = (0, _vue.ref)(true);
    var audioCanPlay = (0, _vue.ref)(false);
    var recorder = null;
    var currentScore = 0;
    var recordDeviceNormal = (0, _vue.ref)(true);
    var resultAudio;
    var resultAudioPath = undefined;
    var sheetMusicEl = (0, _vue.ref)();
    var sheetMusicContainerEl = (0, _vue.ref)();
    var sheetMusicBusiness = (0, _vue.shallowRef)();
    var partInfo = [];

    var _useSheetMusicBusines = (0, _useSheetMusicBusiness.default)(),
        loadSheetMusic = _useSheetMusicBusines.loadSheetMusic,
        sheetMusicRuntimeInit = _useSheetMusicBusines.sheetMusicRuntimeInit,
        loadSheetMusicBySvgStr = _useSheetMusicBusines.loadSheetMusicBySvgStr;

    var _useSheetMusicPlay = (0, _useSheetMusicPlay2.default)(),
        setPlayTool = _useSheetMusicPlay.setPlayTool,
        clickPlay = _useSheetMusicPlay.clickPlay,
        preFetchAudio = _useSheetMusicPlay.preFetchAudio,
        playerCallBack = _useSheetMusicPlay.playerCallBack; // 加载Fluidsynthjs进度回调


    var loadFluidsynthjsProgress = function loadFluidsynthjsProgress(progress) {
      if (progress.percentage < 100) {
        loading.value = true;
        loadingTip.value = "\u6B63\u5728\u4E0B\u8F7D\u97F3\u8272\u5E93".concat(progress.percentage, "%");
        ctx.emit('onLoading', true, loadingTip.value);
      } else {
        loading.value = false;
        loadingTip.value = '设置曲谱中...';
        ctx.emit('onLoading', false);
      }
    };

    var businessOptions = _lodash.default.merge({}, {
      userOptions: {
        fontSize: 40,
        pageWidth: 1000,
        lyricsMargin: 2,
        showAuxItem: false
      },
      playerOptions: {
        playerToolType: 'Mp3',
        playerType: 'fluidsynthjs',
        instrumentBaseUrl: 'https://music-score.ecoach.evideo.tech/',
        fluidsynthLibHost: process ? ((_a = process.env) === null || _a === void 0 ? void 0 : _a.VUE_APP_HOST) || '' : '',
        loadFluidsynthjsSoundFont: props === null || props === void 0 ? void 0 : props.loadFluidSynthJs,
        loadFluidsynthjsProgress: loadFluidsynthjsProgress
      },
      pluginOptions: {
        Highlight: {
          enable: true
        },
        BeatRender: {
          enable: true,
          params: [false]
        }
      }
    }, props.sheetOption || {});

    var playEvents = (0, _vue.ref)({
      ON_INIT: function ON_INIT(playerTool) {
        console.log('ON_INIT');
        playerTool.plugin.$highlight.enable(); // playerTool.plugin.$openAreaSelection.enable()
      },
      ON_PERPARE: function ON_PERPARE(playerTool) {
        console.log('ON_PERPARE');
        playerTool.plugin.$highlight.enable();
      },
      ON_START: function ON_START(playerTool) {
        console.log('ON_START');
        isPlaying.value = true;
        playerTool.plugin.$highlight.enable();
      },
      ON_PAUSE: function ON_PAUSE() {
        console.log('ON_PAUSE');
        isPlaying.value = true;
      },
      ON_CONTINUE: function ON_CONTINUE(playerTool) {
        console.log('ON_CONTINUE');
        isPlaying.value = true;
        playerTool.plugin.$highlight.enable();
      },
      ON_STOP: function ON_STOP(playerTool) {
        console.log('ON_STOP');
        isPlaying.value = false;
        playerTool.plugin.$highlight.scrollToTop(false);
        playerTool.plugin.$highlight.disable();
      },
      ON_TIME_UPDATE: function ON_TIME_UPDATE() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        (0, _objectDestructuringEmpty2.default)(_ref);
      },
      ON_DESTORYED: function ON_DESTORYED(playerTool) {
        console.log('ON_DESTORYED');
        playerTool.plugin.$highlight.disable();
      },
      ON_INIT_PLAYERTOOL: function ON_INIT_PLAYERTOOL(_ref2) {
        var state = _ref2.state;
        console.log('ON_INIT_PLAYERTOOL', state);
        isInitPlayerTool.value = state;
      }
    });
    var recordScoreParams = (0, _vue.reactive)({
      inputChannel: 1,
      sampleRate: 16000,
      options: {
        srcSampleRate: 16000
      }
    });
    var recordTimeParam = {
      isNeedGap: false,
      isNeedSrcTime: false,
      isNeedLyrics: true,
      isNeedLude: false
    };
    var midiPlayTimeParam = {
      isNeedGap: false,
      isNeedSrcTime: false,
      isNeedLyrics: true,
      isNeedLude: true
    }; //停止录音评分

    var stopRecordingScore = function stopRecordingScore() {
      return new Promise(function (resolve) {
        var _a;

        recorder && recorder.stop();
        currentScore = recorder ? (_a = recorder === null || recorder === void 0 ? void 0 : recorder.getScore()) === null || _a === void 0 ? void 0 : _a.totalScore : 0;
        recorder === null || recorder === void 0 ? void 0 : recorder.getMp3().then(function (mp3) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    resultAudio = mp3;
                    resultAudioPath = window.URL.createObjectURL(mp3); // props.debugger &&
                    //   console.log('UserPlayInfoInJson', await recorder.getUserPlayInfo('P1'));

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        }).catch(function (e) {
          console.log('error', e);
          resultAudio = new Blob();
          resultAudioPath = window.URL.createObjectURL(new Blob());
        }).finally(function () {
          props.debugger && console.log("\u8BC4\u5206\u7ED3\u675F\uFF0C\u5F53\u524D\u8BC4\u5206\u7ED3\u679C\uFF1A".concat(currentScore));
          props.debugger && console.log("\u5F55\u97F3\u7ED3\u675F\uFF0C\u5F53\u524D\u5F55\u97F3\u7ED3\u679C\uFF1A".concat(resultAudioPath));
          ctx.emit('recordSuccess', resultAudio, resultAudioPath, currentScore);
          resolve('录音评分完成');
        });
      });
    };

    var startStander = function startStander(e) {
      e.stopImmediatePropagation();
      var audio = new Audio(_A.default);
      audio.play();
    };

    var startRecordScore = _lodash.default.debounce(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return sheetMusicBusiness.value.changePlayerTool('Midi');

              case 2:
                setPlayTool(sheetMusicBusiness.value.playerTool);

                if (recordDeviceNormal.value) {
                  isSingPlaying.value = true;
                  clickPlay('start', {
                    isNoVolume: midiTestRecordScore.value,
                    isBeat: false,
                    isRhythm: false,
                    partInfo: partInfo
                  }, function (state) {
                    if (state === 'start' && isSingPlaying.value) {
                      recorder && recorder.start();
                    }
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }, 500, {
      leading: true,
      trailing: false
    });

    var startSing = function startSing(e) {
      e.stopImmediatePropagation();

      if (!isSingPlaying.value) {
        if (replayVisible.value) {
          // 确认是否重新演唱
          ctx.emit('onReSingConfirm', startRecordScore);
          return;
        } else {
          startRecordScore();
        }
      } else {
        clickPlay('stop', {
          isNoVolume: midiTestRecordScore.value,
          isBeat: false,
          isRhythm: false,
          partInfo: partInfo
        });
      }
    };

    var startReplay = function startReplay(e) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e.stopImmediatePropagation();

                if (isReplayPlaying.value) {
                  _context3.next = 12;
                  break;
                }

                if (resultAudioPath) {
                  _context3.next = 5;
                  break;
                }

                ctx.emit('onError', '录音文件未生成');
                return _context3.abrupt("return");

              case 5:
                _context3.next = 7;
                return sheetMusicBusiness.value.changePlayerTool('Mp3');

              case 7:
                setPlayTool(sheetMusicBusiness.value.playerTool);
                isReplayPlaying.value = true;
                clickPlay('start', {
                  url: resultAudioPath,
                  timeIteratorParams: midiPlayTimeParam,
                  partInfo: partInfo
                });
                _context3.next = 13;
                break;

              case 12:
                clickPlay('stop', {
                  url: resultAudioPath,
                  timeIteratorParams: midiPlayTimeParam,
                  partInfo: partInfo
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    };

    var destroyAll = function destroyAll() {
      var isDestoryRecorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // 给父组件提供停止播放、停止和生成录音评分方法
                destroyAllFlag.value = true;

                if (!isSingPlaying.value) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return stopRecordingScore();

              case 4:
                if (isPlaying.value) {
                  clickPlay('stop', {
                    timeIteratorParams: {
                      isNeedLude: true
                    },
                    partInfo: partInfo
                  });
                }

                if (recorder && isDestoryRecorder) {
                  console.log('recorder-destroy');
                  recorder.destroy();
                  recorder = null;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    };

    var initAudio = function initAudio() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _b;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!props.preloadAudio) {
                  _context5.next = 19;
                  break;
                }

                ctx.emit('onLoading', false);
                _context5.prev = 2;

                if (!props.song.recordFileUrl) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 6;
                return preFetchAudio((_b = props.song) === null || _b === void 0 ? void 0 : _b.recordFileUrl);

              case 6:
                _context5.t0 = _context5.sent;

                if (_context5.t0) {
                  _context5.next = 9;
                  break;
                }

                _context5.t0 = '';

              case 9:
                resultAudioPath = _context5.t0;

              case 10:
                audioCanPlay.value = true;

                if (isInitPlayerTool.value) {
                  ctx.emit('audioCacheSuccess', 'audio缓存成功');
                }

                _context5.next = 19;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t1 = _context5["catch"](2);
                ctx.emit('audioCacheError', 'audio缓存失败');
                initSuccess.value = false;
                throw _context5.t1;

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 14]]);
      }));
    };

    var initRecorder = function initRecorder() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var pitchInfo;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!props.disabled) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                _context6.prev = 2;
                pitchInfo = sheetMusicBusiness.value.getPitchInfo({}, recordTimeParam);
                recorder = _webMusicGrade.RecorderFactory.createWebMusicGradeRecorder({
                  sampleRate: recordScoreParams.sampleRate,
                  inputChannel: recordScoreParams.inputChannel,
                  batch: 8,
                  timeout: 30000,
                  mp3WorkerPathPrefix: recordScoreParams.mp3WorkerPathPrefix || ''
                });
                recorder.pitchInfos = pitchInfo;
                console.log('recorder创建成功');
                _context6.next = 9;
                return recorder.init();

              case 9:
                recordDeviceNormal.value = true;
                _context6.next = 18;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](2);
                recordDeviceNormal.value = false;
                console.error('录音开启异常', _context6.t0);
                ctx.emit('onError', '录音开启失败');
                throw _context6.t0;

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 12]]);
      }));
    };

    var playCallBack = function playCallBack(res) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var _res$data$state, state;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!res.success) {
                  _context7.next = 4;
                  break;
                }

                _res$data$state = res.data.state, state = _res$data$state === void 0 ? 'finish' : _res$data$state;
                _context7.next = 4;
                return playerCallBack(state);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    };

    var parseJsBridgeResult = function parseJsBridgeResult(result) {
      var res = JSON.parse(result) || {};
      res.success = res.eventCode > 0;
      return (0, _extends2.default)({
        success: false,
        eventCode: 0,
        data: null
      }, res);
    };

    var setCallBackEvent = function setCallBackEvent(data) {
      var res = parseJsBridgeResult(data) || {};
      playCallBack(res);
    };

    (0, _vue.watch)(function () {
      return isPlaying.value;
    }, function (newVal) {
      if (newVal === false) {
        if (isSingPlaying.value === true) {
          if (recorder && !destroyAllFlag.value) {
            // 仅在点击停止演唱按钮执行
            stopRecordingScore();
          } // 演唱完一遍后，回放按钮可见


          if (replayVisible.value === false) {
            replayVisible.value = true;
          }
        }

        isPlaying.value = false;
        isSingPlaying.value = false;
        isReplayPlaying.value = false;
      }
    });
    (0, _vue.watch)(function () {
      return isInitPlayerTool.value;
    }, function () {
      if (isInitPlayerTool.value && audioCanPlay.value) {
        ctx.emit('audioCacheSuccess', 'audio缓存成功');
      }
    });
    (0, _vue.onMounted)(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var _c, jsBridge;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                loading.value = true;
                initSuccess.value = true;
                ctx.emit('onLoading', true);
                _context8.next = 5;
                return (0, _vue.nextTick)();

              case 5:
                _context8.prev = 5;
                _context8.next = 8;
                return sheetMusicRuntimeInit();

              case 8:
                _context8.next = 17;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](5);
                loading.value = false;
                initSuccess.value = false;
                ctx.emit('onLoading', false);
                ctx.emit('onError', _context8.t0);
                return _context8.abrupt("return");

              case 17:
                if ((_c = props.song) === null || _c === void 0 ? void 0 : _c.sheetFileUrl) {
                  _context8.next = 24;
                  break;
                }

                ctx.emit('onError', '没有曲谱文件');
                console.error('没有曲谱文件');
                loading.value = false;
                initSuccess.value = false;
                ctx.emit('onLoading', false);
                return _context8.abrupt("return");

              case 24:
                if (window.WebViewJavascriptBridge) {
                  console.log('已进入安卓环境');
                  jsBridge = window.WebViewJavascriptBridge;
                  jsBridge.registerHandler('setCallBackEvent', setCallBackEvent);
                  businessOptions.playerOptions.playerType = 'fluidsynth';
                }

                sheetMusicContainerEl.value = props.sheetMusicSingEl || sheetMusicEl.value;
                svgContainerVisible.value = !props.sheetMusicSingEl;
                businessOptions.userOptions.scaleCase = sheetMusicContainerEl.value.offsetWidth / 1920;

                if (!(props.loadSheetMode === 'common')) {
                  _context8.next = 34;
                  break;
                }

                _context8.next = 31;
                return loadSheetMusic(sheetMusicContainerEl.value, businessOptions, props.song.sheetFileUrl);

              case 31:
                sheetMusicBusiness.value = _context8.sent;
                _context8.next = 38;
                break;

              case 34:
                if (!(props.loadSheetMode === 'svgStr')) {
                  _context8.next = 38;
                  break;
                }

                _context8.next = 37;
                return loadSheetMusicBySvgStr(sheetMusicContainerEl.value, businessOptions, props.song.sheetFileUrl, props.svgApi);

              case 37:
                sheetMusicBusiness.value = _context8.sent;

              case 38:
                if (props.recordScoreOptions) {
                  (0, _extends2.default)(recordScoreParams, props.recordScoreOptions || {});
                }

                if (sheetMusicBusiness.value) {
                  _context8.next = 46;
                  break;
                }

                ctx.emit('onError', '加载曲谱失败');
                console.error('加载曲谱失败');
                loading.value = false;
                initSuccess.value = false;
                ctx.emit('onLoading', false);
                return _context8.abrupt("return");

              case 46:
                sheetMusicBusiness.value.initPlayerTool(playEvents.value);

                if (props.midiTestRecordScore) {
                  midiTestRecordScore.value = false;
                } else {
                  midiTestRecordScore.value = true;
                }

                replayVisible.value = !!props.song.recordFileUrl;
                partInfo = sheetMusicBusiness.value.getMultiPart().scoreparts || [];
                _context8.prev = 50;
                _context8.next = 53;
                return initRecorder();

              case 53:
                _context8.next = 55;
                return initAudio();

              case 55:
                _context8.next = 63;
                break;

              case 57:
                _context8.prev = 57;
                _context8.t1 = _context8["catch"](50);
                loading.value = false;
                initSuccess.value = false;
                ctx.emit('onLoading', false);
                return _context8.abrupt("return");

              case 63:
                loading.value = false;

                if (isInitPlayerTool.value) {
                  ctx.emit('onLoading', false);
                }

              case 65:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[5, 10], [50, 57]]);
      }));
    });
    (0, _vue.onBeforeUnmount)(function () {
      var _a, _b, _c;

      if (isPlaying.value) {
        clickPlay('stop', {
          partInfo: partInfo
        });
      }

      if (recorder) {
        console.log('recorder-destroy');
        recorder.destroy();
        recorder = null;
      } // 销毁sheetMusicBusiness实例


      if (sheetMusicBusiness.value) {
        (_b = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool) === null || _b === void 0 ? void 0 : _b.destroyed();
        (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.destroyed();
      }

      if (resultAudioPath) {
        window.URL.revokeObjectURL(resultAudioPath);
      }
    });
    return {
      props: props,
      loading: loading,
      audioCanPlay: audioCanPlay,
      isPlaying: isPlaying,
      initSuccess: initSuccess,
      isSingPlaying: isSingPlaying,
      isReplayPlaying: isReplayPlaying,
      recordDeviceNormal: recordDeviceNormal,
      svgContainerVisible: svgContainerVisible,
      replayVisible: replayVisible,
      sheetMusicEl: sheetMusicEl,
      initAudio: initAudio,
      initRecorder: initRecorder,
      startStander: startStander,
      startSing: startSing,
      startRecordScore: startRecordScore,
      startReplay: startReplay,
      destroyAll: destroyAll,
      stopRecordingScore: stopRecordingScore,
      loadingTip: loadingTip,
      isInitPlayerTool: isInitPlayerTool,
      destroyAllFlag: destroyAllFlag
    };
  },
  render: function render() {
    var _a;

    return (0, _vue.createVNode)(_vue.Fragment, null, [this.svgContainerVisible && (0, _vue.createVNode)("div", {
      "class": "sheet-music-sing-components-container"
    }, [(0, _vue.createVNode)(_spin.default, {
      "spinning": this.loading,
      "size": "large",
      "tip": this.loadingTip,
      "indicator": function indicator() {
        return (0, _vue.h)('span');
      }
    }, {
      default: function _default() {
        return [(0, _vue.createVNode)("div", {
          "id": "paper",
          "ref": "sheetMusicEl"
        }, null)];
      }
    })]), !this.loading && this.initSuccess && this.isInitPlayerTool && (0, _vue.createVNode)("div", {
      "class": "sheet-music-sing-btn",
      "style": ((_a = this.props) === null || _a === void 0 ? void 0 : _a.style) || {}
    }, [(0, _vue.createVNode)("button", {
      "class": ['stander-sing', [this.isReplayPlaying ? 'btn-play-disabled' : '']],
      "disabled": this.isReplayPlaying,
      "onClick": this.startStander
    }, [(0, _vue.createTextVNode)("\u6807\u51C6\u97F3")]), (0, _vue.createVNode)("button", {
      "class": ['start-sing', !this.recordDeviceNormal || this.isPlaying && !this.isSingPlaying || this.props.disabled ? 'btn-play-disabled' : ''],
      "disabled": !this.recordDeviceNormal || this.isPlaying && !this.isSingPlaying || this.props.disabled,
      "onClick": this.startSing
    }, [this.isSingPlaying ? '停止演唱' : '', !this.replayVisible && !this.isSingPlaying ? '开始演唱' : '', this.replayVisible && !this.isSingPlaying ? '重新演唱' : '']), (0, _vue.createVNode)("button", {
      "class": ['replay-sing', this.isPlaying && !this.isReplayPlaying ? 'btn-play-disabled' : '', this.replayVisible ? '' : 'btn-play-none'],
      "disabled": this.isPlaying && !this.isReplayPlaying,
      "onClick": this.startReplay
    }, [this.isReplayPlaying ? '停止' : '回放'])])]);
  }
});

SheetMusicSing.install = function (app) {
  app.component(SheetMusicSing.name, SheetMusicSing);
  return app;
};

var _default2 = SheetMusicSing;
exports.default = _default2;